export default {"src":"/_next/static/media/dice.283bd1af.svg","height":48,"width":48};